// Import-free on purpose: both callers sit on the col-def ↔ store/User cycle that a value import half-initializes.

// A portal account id read back from a uuid column arrives lowercased while the same id routed through Salesforce keeps its casing; the api folds for exactly this reason.
export const sameAccount = (one?: string | null, other?: string | null): boolean =>
  !!one && !!other && one.toLowerCase() === other.toLowerCase();

// Order-free, so the same accounts selected in another order name the same scope.
export const accountScopeKey = (accountIds: string[]): string => [...accountIds].sort().join(',');
